import { render, staticRenderFns } from "./quality_work_edit.vue?vue&type=template&id=648cc72e&scoped=true"
import script from "./quality_work_edit.vue?vue&type=script&lang=js"
export * from "./quality_work_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648cc72e",
  null
  
)

export default component.exports